import * as React from 'react';
import { useState } from "react";
import {
  Card
} from 'one-ui-card/src/card';
import Table from "antd/lib/table";
import Dropdown from "antd/lib/dropdown";
import Button from "antd/lib/button";
import Menu from "antd/lib/menu";
import { format } from 'one-util-date';
import Modal from "antd/lib/modal";
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import Row from 'antd/lib/row';
import Form from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import Collapse from 'antd/lib/collapse';
import {
  InteractionModel
} from './model';

import {
  InteractionCardProps
} from './props';
const { Panel } = Collapse;
/**
 * This function returns the Interaction Tab
 * @param props is a component property
 * @returns JSX code for Interaction Tab Card
 */
export const InteractionsCard = <M extends InteractionModel>(
  props: InteractionCardProps<M>
) => {
  const {
    model,
  } = props;

  const {
    data
  } = model || {};

  let modalUI = <></>
  const [moredetmodel, setMoredetmodel] = useState(false);
  const [moredetails, setMoredetails] = useState({});
  const [filterinteraction, setfilterInteraction] = useState(data);
  const [incidentkey, setIncidentKey] = useState('');

  const menu = (e: any) => (

    <Menu onClick={handleMenuClick}>
      <Menu.Item key={e.key + ",1"} onClick={()=> setMoredetails(e)}>View Interactions</Menu.Item>
      <Menu.Item key={e.key + ',2'}>
        <a href={`https://dev117142.service-now.com/nav_to.do?uri=interaction.do?sys_id=${e.sys_id}`} target="_blank">
          Open in ServiceNow
        </a>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Description',
      key: 'short_description',
      dataIndex: 'short_description',
      ellipsis:true
    },
    {
      title: 'Interaction Number',
      key: 'number',
      dataIndex: 'number',
    },
    {
      title: 'Assignee',
      key: 'assigned_to',
      dataIndex: 'assigned_to',
      sorter: (a: any, b: any) => a.assigned_to < b.assigned_to ? 1 : -1,
    },
    {
      title: 'Created Date',
      key: 'sys_created_on',
      dataIndex: 'sys_created_on',
      sorter: (a: any, b: any) => a.sys_created_on < b.sys_created_on ? 1 : -1,
      render: (date: Date) => <>{date ? format(date, 'YYYY-MM-DD') : '-'}</>,
    },
    {
      title: "Action",
      key: "action",
      render: (text: any, record: any) => (
        <Dropdown overlay={menu(record)}>
          <Button type="link" size="small" className="ant-btn-link--dark">&hellip;</Button>
        </Dropdown>
      )
    }
  ];

  const handleMenuClick = (e: any) => {
    let key = e.key;
    let res = key.split(",");
    if (res[1] === '1') {
      setMoredetmodel(true);
    }
  }

  const handleCancel = (e: any) => {
    setMoredetmodel(false);
  };

  const handleKeyChange = (event: any) => {
    setIncidentKey(event.target.value);
    if(data?.length > 0) {
      const tablefilter = data.filter((searchdata:any)=> (searchdata.number.includes(event.target.value.toUpperCase()) || searchdata.sys_created_on.includes(event.target.value) || searchdata.short_description.toUpperCase().includes(event.target.value.toUpperCase())))
      setfilterInteraction(tablefilter)
    }
  };

  modalUI = (
    <>
    <Row gutter={[0, 16]}>
      <Col>
        <Row type="flex">
        <Col>
          <Input size="default" placeholder="Search By Date or Interaction Number or Description" value={incidentkey}  onChange={handleKeyChange} className='incident_search' />
        </Col>
        </Row>
      </Col>
      <Col span={24}>
      <Table
        className="ant-table--smaller"
        columns={columns}
        dataSource={filterinteraction}
      />
      </Col>
    </Row>

    <Modal
      title="Interaction Details" 
      visible={moredetmodel}
      centered
      destroyOnClose
      onCancel={handleCancel}
      cancelText="Close"
      cancelButtonProps={{
        type: 'primary',
      }}
      wrapClassName="custom-modal-wrap"
      width={768}
      onOk={null}
      footer={null}
    >
      <Form>
        <Row gutter={[16, 16]}>
          <Col md={8} span={24}>
            <text>Number:</text>
            <Form.Item>
              <Input name="number" placeholder="Number"  value={moredetails != undefined ? moredetails.number : ""} readOnly />
            </Form.Item>
          </Col>
          <Col md={8} span={24}>
            <text>Caller:</text>
            <Form.Item>
              <Input name="caller" placeholder="Caller" value={moredetails != undefined ? moredetails.assigned_to : ""} readOnly />
            </Form.Item>
          </Col>
          <Col md={8} span={24}>
            <text>Opened</text>
            <Form.Item>
              <Input name="opened" placeholder="Opened" value={moredetails != undefined ? moredetails.sys_created_on : ""} readOnly />
            </Form.Item>
          </Col>
          <Col md={8} span={24}>
            <text>Opened by</text>
            <Form.Item>
              <Input name="openedBy" placeholder="Opened by" value={moredetails != undefined ? moredetails.assigned_to : ""} readOnly />
            </Form.Item>
          </Col>
          <Col md={8} span={24}>
            <text>Type:</text>
            <Form.Item>
              <Input name="type" placeholder="Type" value={moredetails != undefined ? moredetails.type : ""} readOnly />
            </Form.Item>
          </Col>
          <Col md={24} span={24}>
            <text>Description:</text>
            <Form.Item>
              <TextArea name="description" value={moredetails != undefined ? moredetails.short_description : ""} placeholder="Description" readOnly />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="">
        <Button type="primary" onClick={handleCancel}>Close</Button>
      </div>
    </Modal>
    </>
  )

  return (
    <Card
      title={""}
      body={modalUI}
    />
  )
}
